import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Icon from 'discada/dist/Icon'
import Button from 'discada/dist/Button'
import Menuing from 'components/widgets/Menuing'

import * as QS from 'selectors/quoteSelectors'
import { getBankByCode } from 'selectors/appStatusSelectors'

import { percentShort, money } from 'utils'
import { updateQuote } from 'actions/quoteActions'

const DETAIL_FIELDS = {
  Lender: { label: 'Lender', type: 'text' },
  CreditRange: {
    label: 'Credit Score',
    value: p => (
      <span>
        {p.MinCreditScore || 1} &mdash; {p.MacCreditScore || 1000}
      </span>
    ),
  },
  OutOfPocketCash: { label: 'Money Down', type: 'money' },
  /*AppliedRebates: {
    label: 'Applied Rebates',
    value: (p, { appliedRebateTotal }) => (
      <span>{money(appliedRebateTotal)}</span>
    ),
  },*/
  /*AvailableRebates: {
    label: 'Available Rebates',
    value: (p, { availableRebateTotal }) => (
      <span>{money(availableRebateTotal)}</span>
    ),
  },*/
  //InceptionFeesTaxes: { label: 'Inception Fees & Taxes', type: 'money' },
  Advance: {
    label: 'Advance (Max)',
    value: p => (
      <span>
        {money(p.AmountFinanced)} ({money(p.MaxAdvance)})
      </span>
    ),
  },
  AdvanceNotice: {
    label: 'Advance Headroom',
    value: p => {
      let headroom = -1 * (p.AmountFinanced - p.MaxAdvance)

      return (
        <span className={c({ warning: headroom < 0 })}>{money(headroom)}</span>
      )
    },
    className: p => p.AmountFinanced - p.MaxAdvance < 0,
  },

  Rate: {
    label: 'Rate (Buy Rate)',
    value: p => {
      return (
        <span>
          {parseFloat(p.Rate || 0)} ({parseFloat(p.BuyRate || 0)})
        </span>
      )
    },
  },
  Residual: {
    label: 'Residual',
    value: p => (
      <span>
        {parseFloat(p.ResidualPercent) > 100
          ? money(p.ResidualPercent)
          : percentShort(p.ResidualPercent / 100)}
      </span>
    ),
  },
  PaidReserve: {
    label: 'Paid Reserve',
    value: p => <span>{money(p.PaidReserve)}</span>,
  },
  Profit: {
    label: 'Total Profit',
    value: p => <span>{money(p.Profit)}</span>,
  },
}

export function FinePrint(props) {
  let {
    vehicleId,
    quoteId,
    programKey,
    program,
    unselect,
    className,
    updateQuote,
    bestProgramKey,
  } = props

  let applyProgram = () => {
      updateQuote(
        vehicleId,
        quoteId,
        QS.explodeProgramKey(programKey),
        false,
        true,
      )
    },
    isSelected = bestProgramKey === programKey

  return (
    <div
      className={c('program-fine-print', className, {
        'is-selected-program': isSelected,
      })}
    >
      <h4>
        <span>
          {program.mode === 'loan' ? 'Loan' : 'Lease'} for{' '}
          {money(program.Payment)} for {program.term} mo.
          {isSelected ? (
            <small className="selected-program-message">
              This is the applied program & payment
            </small>
          ) : (
            <small className="non-selected-program-message">
              You have not applied program yet{' '}
            </small>
          )}
        </span>
        <Icon icon="times" className="close" size="small" onClick={unselect} />
      </h4>
      <Menuing
        noCheck
        items={Object.keys(DETAIL_FIELDS).filter(
          k =>
            !(k === 'Residual' && program.mode === 'loan') &&
            (!DETAIL_FIELDS[k].hide || !DETAIL_FIELDS[k].hide(program)),
        )}
        labelRenderer={k => DETAIL_FIELDS[k].label}
        valueRenderer={k => {
          if (DETAIL_FIELDS[k].value)
            return DETAIL_FIELDS[k].value(program, props)

          let v = get(program, k, 'TODO')

          return DETAIL_FIELDS[k].type === 'money' ? money(v) : v
        }}
      />

      <p className="fine-print-footer">
        <strong>Program Description:</strong>{' '}
        {get(program, `ProgramDescription`)}
      </p>

      {program.mode === 'lease' && (
        <p className="fine-print-footer">
          <strong>Residual Name:</strong> {get(program, `ResidualName`)}
        </p>
      )}

      {program.Rejections && (
        <p className="fine-print-footer rejections">
          This program may require lender approval or other special
          requirements.
          <br />
          Apply, then check the Payment Summary section for more info.
        </p>
      )}

      <div className="controls">
        {!isSelected ? (
          <Button size="small" onClick={applyProgram} success>
            Apply this program
          </Button>
        ) : null}

        <Button size="small" onClick={unselect} text>
          Close
        </Button>
      </div>
    </div>
  )
}

function mapStateToProps(state, op) {
  let program = QS.getQuoteValue(
    state,
    op.vehicleId,
    op.quoteId,
    `programs[${op.programKey}]`,
  )

  return {
    ...op,
    program: {
      ...program,
      ...QS.explodeProgramKey(op.programKey),
      Lender: getBankByCode(state, get(program, 'Lender')),
    },
    bestProgramKey: QS.getBestProgramKey(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
    ),
  }
}

export default connect(
  mapStateToProps,
  { updateQuote },
)(FinePrint)
